import {Component} from '@angular/core';
import {CrudEdit} from '../../../../../shared/components/crud-edit';
import {AbstractBffApi} from '../../../../../models/sharedinterface';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiFactoryService} from '../../../../../shared/services/api-factory.service';
import {CrudAttributeTypeService} from '../../../../../shared/services/crud-attribute-type.service';

@Component({
  selector: 'app-attribute-type-edit',
  templateUrl: './attribute-type-edit.component.html',
  styleUrls: ['./attribute-type-edit.component.scss']
})
export class AttributeTypeEditComponent extends CrudEdit {
  private bffapi: AbstractBffApi;

  constructor(
    protected httpcrud: CrudAttributeTypeService, // Specific
    protected fb: UntypedFormBuilder,
    protected route: ActivatedRoute,
    protected router: Router,
    private apifactory: ApiFactoryService
  ) {
    super(httpcrud, fb, route, router);
    this.bffapi = this.apifactory.createBffApi();
  } // constructor

  initSpecificEditConfig() {
    // Specific
    this.entitylabelkey = 'label';
    this.redirecturl = '/admin/attributes';

    this.entityformconfig = [
      {field: 'attribute', fieldlabel: 'attribute', fieldtype: 'text', required: true},
      {field: 'defaultValue', fieldlabel: 'defaultValue', fieldtype: 'text'},
      {field: 'description', fieldlabel: 'description', fieldtype: 'text'},
      {
        field: 'type', fieldlabel: 'type', fieldtype: 'select',
        choices: [{id: 'text', label: 'text'}, {id: 'textarea', label: 'textarea'}]
      },
      {field: 'aoptool_fkid', fieldlabel: 'aopTool', fieldtype: 'select', choices: []},
    ];

    this.httpcrud.getToolsList()
      .subscribe(allresults => {
        const toolsList = allresults.results;
        for (const tool of toolsList) {
          this.entityformconfig[4].choices.push(tool); // 4 is for aopTool_fkID
        } // for
      }); // subscribe
  } // initSpecificConfig


  onSubEntityFormSubmit() {
    let pathURL = window.location.pathname;

    let AttrGroupURL = pathURL.slice(0, pathURL.lastIndexOf('/'));
    AttrGroupURL = AttrGroupURL.slice(0, AttrGroupURL.lastIndexOf('/'));

    this.submittedEntityForm = true;

    if (this.entityForm.valid) {
      const entityjson = this.entityForm.getRawValue();
      if (this.entityid) {
        const query = this.httpcrud.updateEntity(this.entityid, entityjson);
        query.subscribe((allresults) => {
          this.router.navigate([AttrGroupURL]);
        });
      } else {
        const AttrGroupURLArray = AttrGroupURL.split('/');
        for (const attributegroupid of AttrGroupURLArray) {
          if (Number(attributegroupid)) {
            const query = this.httpcrud.createEntity(entityjson, attributegroupid);
            query.subscribe((allresults) => {
              pathURL = pathURL.slice(0, pathURL.lastIndexOf('/'));
              this.router.navigate([pathURL]);
            });
          } // if
        } // for
      } // if
    } // if

  } // onSubEntityFormSubmit


  cancelSubFormSubmit() {
    let pathURL = window.location.pathname;
    pathURL = pathURL.slice(0, pathURL.lastIndexOf('/'));

    if (this.entityid) {
      pathURL = pathURL.slice(0, pathURL.lastIndexOf('/'));
      this.router.navigate([pathURL]);
    } else {
      this.router.navigate([pathURL]);
    } // if else
  } // cancelSubFormSubmit


}
